import { useWatch } from "react-hook-form"
import type { FormValues } from "../../../UserForm.component"
import { fields } from "../GeneralInfos.fields"

export const useGetUserTypeField = () => {
  return useWatch<FormValues, "type">({ name: fields.type })
}
